export const createBinaryExpression = (
  operatorDef: Record<string, unknown>,
  left: unknown,
  right: unknown,
): unknown => {
  if (!operatorDef?.operator) throw new Error('malformed operator');

  if (
    operatorDef?.expressionType !== 'binary' &&
    operatorDef?.expressionType !== 'null'
  )
    throw new Error(
      `operator of expressionType '${operatorDef.expressionType}' is incompatible with binary expressions`,
    );

  if (!left)
    throw new Error(`binary expression requires non-empty left expression`);

  if (!right)
    throw new Error(`binary expression requires non-empty left expression`);

  return {
    expressionType: 'binary',
    left,
    operator: operatorDef.operator,
    right,
  };
};
